// extracted by mini-css-extract-plugin
export var orderDetails = "_pj-2";
export var orderImage = "_pj-1";
export var orderMeta = "_pj-3";
export var orderSummary = "_pj-0";
export var rightArrow = "_pj-4";